import { BLANK_SHORTCUTS, DeviceType, KeyboardShortcutType, SHORTCUTS_STORAGE_KEY, } from '#pplx/frontend/apps/ask/keyboards/keyboards-core/consts.js';
import { useNativeBridgeSelector } from '#pplx/frontend/apps/ask/native-bridges/store.js';
import { useLocalStorage } from '#pplx/frontend/browser-storage/hooks/useLocalStorage.js';
import { useCallback, useMemo } from 'react';
export function useKeyboardShortcuts() {
    const defaultGlobalShortcuts = useNativeBridgeSelector((state) => state.defaultGlobalShortcuts);
    const [savedShortcuts, setSavedShortcuts] = useLocalStorage(SHORTCUTS_STORAGE_KEY, BLANK_SHORTCUTS);
    const setShortcut = useCallback((type, device, shortcut) => setSavedShortcuts((shortcuts) => ({
        ...shortcuts,
        [type]: {
            ...(shortcuts[type] || {}),
            [device]: shortcut,
        },
    })), [setSavedShortcuts]);
    const globalShortcuts = useMemo(() => Object.fromEntries(defaultGlobalShortcuts.map((shortcut) => [
        shortcut.type,
        {
            [DeviceType.MACOS]: savedShortcuts[shortcut.type]?.[DeviceType.MACOS] || shortcut.macos,
            [DeviceType.WINDOWS]: savedShortcuts[shortcut.type]?.[DeviceType.WINDOWS] || shortcut.windows,
        },
    ])), [defaultGlobalShortcuts, savedShortcuts]);
    return { globalShortcuts, setShortcut, defaultGlobalShortcuts };
}
//# sourceMappingURL=useKeyboardShortcuts.js.map